// src/pages/Attendance.jsx
import React from 'react';
import '../styles/Attendance.css';
import { CalendarDays, Clock, Users } from 'lucide-react';

const Attendance = () => {
  return (
    <div className="attendance-page">
      <header className="header">
        <h1><CalendarDays size={28} style={{ marginRight: '10px', verticalAlign: 'middle' }} />Attendance</h1>
        <p style={{ color: 'var(--text-secondary)' }}>
          Track daily student and staff attendance records.
        </p>
      </header>

      <section className="card-grid">
        <div className="card">
          <div className="card-icon"><Users size={22} /></div>
          <h3>Student Attendance</h3>
          <p>95% present today</p>
          <span className="badge success">Stable</span>
        </div>

        <div className="card">
          <div className="card-icon"><Clock size={22} /></div>
          <h3>Staff Attendance</h3>
          <p>All staff checked in</p>
          <span className="badge success">On Time</span>
        </div>

        <div className="card">
          <div className="card-icon"><CalendarDays size={22} /></div>
          <h3>Weekly Overview</h3>
          <p>Attendance report for the last 7 days</p>
          <span className="badge info">Download</span>
        </div>
      </section>
    </div>
  );
};

export default Attendance;
